import React, { Component } from 'react';
import AddnewRoles from './AddnewRoles';
import { toast } from 'react-toastify';
import { dataUser } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import SwButton from '../Common/SwButtons/SwButtons';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
export const MyContext = React.createContext();

class MainHeadingAddRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      role_status: 1,
      showAddRoles: false,
    };
    this.addRolesRef = React.createRef();
  }
  closeAddRoles = () => {
    this.setState({ showAddRoles: false });
  };

  addRoleLink() {
    mixpanel.track('Role Management Add new', {
      PageName: 'Roles',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Roles',
    });
  }

  handleRoleSuccess = message => {
    // 1️⃣ show toast (parent stays mounted)
    toast.success(message, { autoClose: 3000 });

    // 2️⃣ close OffCanvas AFTER toast
    setTimeout(() => {
      this.setState({ showAddRoles: false });
    }, 3000);

    // 3️⃣ reload AFTER toast
    setTimeout(() => {
      window.location.reload();
    }, 3300);
  };

  render() {
    const Roles = this.state.userRole.find(
      element => element.service_id == '13',
    );

    return (
      <>
        <SwOffCanvas
          show={this.state.showAddRoles}
          onClose={() => this.setState({ showAddRoles: false })}
          title="Add New Role"
          placement="end"
          backdrop="static"
          keyboard={false}
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton
                variant="dark-outline"
                onClick={() => this.addRolesRef.current?.reload()}
              >
                Reset
              </SwButton>

              <SwButton
                variant="primary"
                className="ml10"
                onClick={e => this.addRolesRef.current?.addroleSubmitHandler(e)}
              >
                Submit Role
              </SwButton>
            </div>
          }
        >
          <AddnewRoles
            ref={this.addRolesRef}
            onSuccess={this.handleRoleSuccess}
            namerole={this.state.role_status}
          />
        </SwOffCanvas>

        {Roles?.role_for_write === '1' && (
          <SwButton
            type="button"
            variant="primary"
            size="sm"
            icon={<i class="bi bi-plus-circle" />}
            iconPosition="start"
            onClick={() => {
              this.addRoleLink();
              this.setState({ showAddRoles: true });
            }}
          >
            Add New Role
          </SwButton>
        )}
      </>
    );
  }
}
export default MainHeadingAddRole;
